//@flow
import { combineReducers } from "redux";
import { reducer as card } from "./common/card/card.reducer";

export const reducer = combineReducers({
  card,
});
